import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';
import * as ItinerariesActions from '../../Itineraries/actions';
import { RootState } from '@Redux/detail/store';

const detailRoute = `${DomainByEnv()}/detail`;

// function* setGroupDetailAsync(
//     action: actions.I_GroupDetailAction
// ): Generator<StrictEffect, any, any> {
//     yield put(actions.setGroupDetailSUCCESS({ isLoading: true }));
//     const detail = yield call(fetchAPI, {
//         url: `${detailRoute}/travelinfojson`,
//         req: action.payload,
//     });

//     yield put(actions.setGroupDetailSUCCESS({ ...detail, isLoading: false }));
// }

// function* watchSetGroupDetailAsync() {
//     yield takeLatest(actionTypes.SET_GROUPDETAIL, setGroupDetailAsync);
// }

function getGroupTourID(state: RootState) {
    return state.groupReducer.GroupInfo.TourID;
}

function getTravelType(state: RootState) {
    return state.groupReducer.GroupInfo.TravelType;
}

function getCurrentTourID(state: RootState) {
    return state.groupReducer.currentTourID;
}

function* setPricesInfoAsync(
    action: actions.I_PricesInfoAction
): Generator<StrictEffect, any, any> {
    const price = yield call(fetchAPI, {
        url: `${detailRoute}/priceinfojson`,
        req: action.payload,
    });

    yield put(actions.setPricesInfoSUCCESS(price));
}

function* watchSetPricesInfoAsync() {
    yield takeLatest(actionTypes.SET_PRICESINFO, setPricesInfoAsync);
}

function* setStationInfoAsync(
    action: actions.I_StationInfoAction
): Generator<StrictEffect, any, any> {
    const station = yield call(fetchAPI, {
        url: `${detailRoute}/stationinfojson`,
        req: action.payload,
    });

    yield put(actions.setStationInfoSUCCESS(station));
}

function* watchSetStationInfoAsync() {
    yield takeLatest(actionTypes.SET_STATIONINFO, setStationInfoAsync);
}

function* setFlightInfoAsync(
    action: actions.I_FlightInfoAction
): Generator<StrictEffect, any, any> {
    const flightInfo = yield call(fetchAPI, {
        url: `${detailRoute}/packageinfojson`,
        req: action.payload,
    });

    yield put(actions.setFlightInfoSUCCESS(flightInfo));
}

function* watchSetFlightInfoAsync() {
    yield takeLatest(actionTypes.SET_FLIGHTINFO, setFlightInfoAsync);
}

export default [
    // watchSetGroupDetailAsync(),
    watchSetStationInfoAsync(),
    watchSetPricesInfoAsync(),
    watchSetFlightInfoAsync(),
];
